import { render, staticRenderFns } from "./ModalEditWorkRestrictionDay.vue?vue&type=template&id=167c8736&scoped=true"
import script from "./ModalEditWorkRestrictionDay.vue?vue&type=script&lang=js"
export * from "./ModalEditWorkRestrictionDay.vue?vue&type=script&lang=js"
import style0 from "./ModalEditWorkRestrictionDay.vue?vue&type=style&index=0&id=167c8736&prod&scoped=true&lang=css"
import style1 from "./ModalEditWorkRestrictionDay.vue?vue&type=style&index=1&id=167c8736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167c8736",
  null
  
)

export default component.exports